// `removeCandidatesFromListAndRefreshPage` (extension-alert-candidates.component.ng1.ts:781) and its
// client-contacts twin (:697) — what an ARCHIVE does to the list, as opposed to the row.
//
// ⚠️ THE ROW LEAVES THE LIST. Upstream drops archived rows from the page, the total and the
// selection unless the filter is one that shows them (Archived, Exported, Messaged), and the page
// backfills from the next one. The port flagged the row archived in place instead, so it stayed on
// screen until a reload — measured 28 Oct beside build 354 on contact alert 20.
//
// ⚠️ AND AN OPEN PREVIEW MOVES ON. When ONE row is archived and it is the row whose preview is
// open, upstream opens the NEXT row's preview (`nextCandidateId = allRelevantIds[index + 1]`); with
// no next row the preview is left to the caller's rule.

/** The three filters under which an archived row still belongs on the page. */
export interface HiddenRowsStayFlags {
  showHidden?: boolean
  showExportedOnly?: boolean
  showMessagedOnly?: boolean
}

export function archivedRowsStay(flags: HiddenRowsStayFlags): boolean {
  return flags.showHidden === true || flags.showExportedOnly === true || flags.showMessagedOnly === true
}

/**
 * The row whose preview should open next, or undefined. Only a SINGLE-row archive of the row that
 * is open advances (`transitionToNext… = ids.length === 1`, `previouslySelected… === ids[0]`).
 */
export function nextRowAfterArchive<T extends { id: number }>(
  rows: readonly T[],
  archivedIds: readonly number[],
  openId: number | undefined,
): T | undefined {
  if (archivedIds.length !== 1 || openId === undefined || archivedIds[0] !== openId) return undefined
  const index = rows.findIndex((row) => row.id === openId)
  if (index < 0) return undefined
  return rows[index + 1]
}

export function withoutRows<T extends { id: number }>(rows: readonly T[], ids: ReadonlySet<number>): T[] {
  return rows.filter((row) => !ids.has(row.id))
}
